/**
 * ValidateInputs / ResetInputs / UpdateAllSelectedCheckBox /
 * UpdateAllHiddenElements — verbatim from v1 everything_else.js
 * (research/01 §5.1; REQ-CHK-10). Note the LOCAL isError shadow: this
 * function never touches the shared appState.isError flag (REQ-STATE-3 —
 * only GetVariantProperties writes it, and nobody reads it).
 *
 * All DOM access via the BUNDLED jQuery (DIV-004; v1 used the theme's).
 */
import { CheckTextInputValidity } from "../elements/build-calculator";
import $ from "jquery";

export function ValidateInputs(): boolean {
  let isError = false;
  $(".calc-prop").each((d: any, elem: any) => {
    let isHidden = $(elem).is(":hidden");
    if (isHidden === false) {
      let value = $(elem).val();
      let isRequired = $(elem).data("isrequired");
      let isChecked = $(elem).is(":checked");
      let elementType = elem.type;

      // Check textarea minlength validation
      if (elem.nodeName === "TEXTAREA") {
        var result = CheckTextInputValidity(elem);
        if (result === false) {
          isError = true;
          return;
        }
      }

      // For file inputs: validate that the upload actually completed
      if (elementType === "file" && isRequired !== undefined && isRequired == true) {
        const filePropName = $(elem).data("property-name");
        const fileHiddenInput = $(
          `input.cpc-file-url-input[data-property-name="${filePropName}"]`,
        );
        const isUploading = $(elem).attr("data-cpc-uploading") === "true";

        if (isUploading || !fileHiddenInput.val()) {
          isError = true;
          $(elem).addClass("error-border");
        }
        return; // skip the generic check below for file inputs
      }

      if (
        isRequired !== undefined &&
        isRequired == true &&
        ((elementType === "checkbox" && isChecked === false) ||
          (elementType !== "checkbox" && value.length <= 0))
      ) {
        console.log("element-if-clause", elem);
        isError = true;
        $(elem).addClass("error-border");
      }
    }
  });

  setTimeout(() => {
    ResetInputs();
  }, 3000);

  return isError;
}

function ResetInputs(): void {
  $(".calc-prop").each((d: any, elem: any) => {
    $(elem).removeClass("error-border");
  });
  $(".cpc-text-error").remove();
}

export function UpdateAllSelectedCheckBox(): void {
  $(".checkbox-element .checkbox:checked").each((d: any, elem: any) => {
    $(elem).val("Yes");
  });
}

// DIV-006 (BUG-028): hidden elements used to be .remove()d outright — fine
// when every submit navigated, but the drawer flow keeps the page alive and
// conditional elements were gone for good. The what-posts contract is
// unchanged (hidden props must never reach the cart): DISABLED inputs are
// excluded from both native form serialization and new FormData(form), same
// as removal was. RestoreAllHiddenElements re-enables exactly the inputs we
// disabled (never ones the theme disabled itself).
const cpcDisabledHiddenInputs: any[] = [];

export function UpdateAllHiddenElements(): void {
  $("#calculator .element:hidden").each((d: any, elem: any) => {
    $(elem)
      .find("input, select, textarea")
      .each((i: any, input: any) => {
        if (!input.disabled) {
          input.disabled = true;
          cpcDisabledHiddenInputs.push(input);
        }
      });
  });
}

export function RestoreAllHiddenElements(): void {
  cpcDisabledHiddenInputs.forEach((input: any) => {
    input.disabled = false;
  });
  cpcDisabledHiddenInputs.length = 0;
}
